export default class Status {
  constructor(obj) {
    this.codigo = obj != null ? obj.codigo : '';
    this.descricao = obj != null ? obj.descricao : '';

    this.cores = {
      REJEITADO: 'error',
      APROVADO: 'green',
      AGUARDA_RECURSO: 'orange',
      NOVO: 'secondary',
      PRAZO_EXPIRADO: 'error'
    };
  }
  get cor(){
    return this.codigo != '' ? this.cores[this.codigo] : 'grey';
  }
}
